export default "__VITE_PUBLIC_ASSET__af2241cf__"